import type { ViewMode } from '../../store/tasksStore';

export type TaskViewFlags = {
  list: boolean;
  board: boolean;
  calendar: boolean;
};

export const ALL_TASK_VIEW_FLAGS: TaskViewFlags = {
  list: true,
  board: true,
  calendar: true,
};

const VIEW_ORDER: ViewMode[] = ['list', 'board', 'calendar'];

function asBool(value: unknown, fallback: boolean): boolean {
  return typeof value === 'boolean' ? value : fallback;
}

export function parseTaskViewFlags(
  input: Partial<TaskViewFlags> | null | undefined,
): TaskViewFlags {
  const flags: TaskViewFlags = {
    list: asBool(input?.list, true),
    board: asBool(input?.board, true),
    calendar: asBool(input?.calendar, true),
  };
  if (!flags.list && !flags.board && !flags.calendar) {
    return { ...ALL_TASK_VIEW_FLAGS };
  }
  return flags;
}

export function enabledViewModes(flags: TaskViewFlags): ViewMode[] {
  return VIEW_ORDER.filter((mode) => flags[mode]);
}

/** Pas de switcher tant que les flags ne sont pas là — ne pas inférer les 3 vues. */
export function showTaskViewSwitcher(
  flags: TaskViewFlags | null | undefined,
): boolean {
  if (!flags) return false;
  return enabledViewModes(flags).length >= 2;
}

export function effectiveViewMode(stored: ViewMode, flags: TaskViewFlags): ViewMode {
  const enabled = enabledViewModes(flags);
  if (enabled.includes(stored)) return stored;
  return enabled[0] ?? 'list';
}

export function assertAtLeastOneTaskView(flags: TaskViewFlags): TaskViewFlags {
  if (!flags.list && !flags.board && !flags.calendar) {
    throw new Error('Au moins une vue de tâches doit rester active');
  }
  return flags;
}
